import React from 'react';
import PropTypes from 'prop-types';
import { isNil, isEmpty } from 'lodash';

import ConnectionParameters from '../ConnectionParameters';
import SubtaskParameters from '../SubtaskParameters';

const NodeParams = ({ selectedNodeId, ...rest }) => {
  if (isNil(selectedNodeId) || isEmpty(selectedNodeId)) return '';
  return (
    <>
      <ConnectionParameters {...rest} selectedNodeId={selectedNodeId} />
      <SubtaskParameters {...rest} selectedNodeId={selectedNodeId} />
    </>
  );
};

NodeParams.defaultProps = {
  selectedNodeId: null
};

NodeParams.propTypes = {
  selectedNodeId: PropTypes.string
};

export default NodeParams;
